import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';
import { mapSectionToCategory } from '../mappers/mapSectionToCategory';
import { ca } from '@cian/analytics';

export interface IChatsNotificatorProps {
  isAuthenticated: boolean;
  baseUrl: string | undefined;
  notificationsCount: number | null;
  section?: string | null;
}

export class ChatsNotificator extends React.Component<IChatsNotificatorProps, {}> {
  public render() {
    const { isAuthenticated, baseUrl, notificationsCount } = this.props;
    const count = Number(notificationsCount);

    return (
      <a
        {...mergeStyles(
          'c-header-messages-container',
          (count === 0 && 'c-header-messages-container--inactive') || undefined,
        )}
        href={isAuthenticated ? `${baseUrl}/dialogs/` : `${baseUrl}/authenticate/`}
        target="_blank"
        onClick={this.handleClick}
      >
        <div className="c-header-messages--adaptive c-header-messages-icon-container">
          {/* tslint:disable:max-line-length */}
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.73758 11.9178L2.89559 11.2331L2.59057 10.6C2.21273 9.81579 2.00002 8.93555 2.00002 8C2.00002 4.68629 4.68631 2 8.00002 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8.00002 14C7.00523 14 6.07246 13.7595 5.25112 13.3351L4.55394 12.9749L3.79783 13.185L2.35251 13.5864L2.73758 11.9178ZM8.00002 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8.00002 0C3.58174 0 2.06676e-05 3.58172 2.06676e-05 8C2.06676e-05 9.24255 0.283298 10.4189 0.788795 11.4681L0.025631 14.7751C-0.0536661 15.1188 0.0538893 15.4787 0.308695 15.7225C0.5635 15.9663 0.92788 16.0579 1.26767 15.9635L4.33312 15.112C5.43158 15.6795 6.67837 16 8.00002 16ZM4.29288 7.29289C4.68341 6.90237 5.31657 6.90237 5.7071 7.29289C6.09762 7.68342 6.09762 8.31658 5.7071 8.70711C5.31657 9.09763 4.68341 9.09763 4.29288 8.70711C3.90236 8.31658 3.90236 7.68342 4.29288 7.29289ZM7.29288 8.70711C7.68341 9.09763 8.31657 9.09763 8.7071 8.70711C9.09762 8.31658 9.09762 7.68342 8.7071 7.29289C8.31657 6.90237 7.68341 6.90237 7.29288 7.29289C6.90236 7.68342 6.90236 8.31658 7.29288 8.70711ZM10.2929 8.70711C10.6834 9.09763 11.3166 9.09763 11.7071 8.70711C12.0976 8.31658 12.0976 7.68342 11.7071 7.29289C11.3166 6.90237 10.6834 6.90237 10.2929 7.29289C9.90236 7.68342 9.90236 8.31658 10.2929 8.70711Z"
              fill="#737A8E"
            />
          </svg>
          {count > 0 && <span className="c-header-active-notification"></span>}
        </div>
      </a>
    );
  }

  private handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const { isAuthenticated } = this.props;

    if (!isAuthenticated) {
      event.preventDefault();

      window.waitForLoginPopup('chats');
    } else {
      ca('event', {
        name: 'oldevent',
        category: mapSectionToCategory(this.props.section),
        action: 'top_menu',
        label: 'messages',
      });
    }
  };
}
